// Cook mode's position, shared between devices. Pure; CookScreen does the IO.
//
// The node is <hat>/cooking/lessons/<id>/live = { phase, prepIndex, stepIndex,
// timers, ticks, updatedAt, by }. Every device writes its own changes with
// its own `by` and the time; every device applies anything NEWER than what it
// last wrote or applied. Timers carry wall-clock `endsAt`, so they are right
// on both screens without any clock agreement beyond "roughly now".

const DEVICE_KEY = 'enjoyCookingDevice';

/** A stable id for this browser, so a device can tell its own echo apart. */
export function deviceId (storage = globalThis.localStorage) {
  try {
    let id = storage.getItem(DEVICE_KEY);
    if (!id) {
      id = Math.random().toString(36).slice(2, 10);
      storage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return Math.random().toString(36).slice(2, 10);
  }
}

export const liveSnapshot = (state, by, now = Date.now()) => ({
  phase: state.phase,
  prepIndex: state.prepIndex,
  stepIndex: state.stepIndex,
  timers: state.timers || [],
  ticks: state.ticks || {},
  updatedAt: now,
  by
});

/** Should an incoming snapshot replace what this device has? Only if newer. */
export const isNewer = (incoming, localUpdatedAt) =>
  Boolean(incoming) && typeof incoming.updatedAt === 'number' && incoming.updatedAt > (localUpdatedAt || 0);
